import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import { FormattedMessage } from 'react-intl'

const Card = props => {
    useStyles(classes)
    const { card, onSelect, showNew } = props
    const {
        isSelected,
        quickpayRecord,
        style
    } = card
    return <div className={classes.Card} onClick={e => onSelect(card)}>
        <span className={classes.CardBody}>
            <span className={classes.Logo} style={{
                backgroundImage: `url(${style?.imageURL})`
            }} />

            <span className={classes.Number}>
                {quickpayRecord.cardNumber}
            </span>
        </span>
        {
            isSelected && !showNew ? <Iconfont className={classes.Selector}>&#xe658;</Iconfont> : <Iconfont className={classes.Selector}>&#xe65a;</Iconfont>
        }
    </div>
}

export default props => {
    useStyles(classes)
    const {
        showNewHandle,
        showNew,
        cardList,
        selectCardHandle
    } = props

    const onSelect = card => {
        showNewHandle(false)
        selectCardHandle(card)
    }

    return <div className={classes.CardListContainer}>
        <div className={classes.Hd}>
            <FormattedMessage id={'select_a_card'} defaultMessage={'Select a Card'}/>
        </div>
        <div className={classes.Bd}>
            {
                cardList?.map((card, index) => <Card showNew={showNew} onSelect={onSelect} key={index} card={card} />)
            }
        </div>

        {
            !showNew && <div className={classes.Fd} onClick={e => showNewHandle(true)}>
                <Iconfont className={classes.AddIcon}>&#xe662;</Iconfont>
                <span><FormattedMessage id={'use_new_card'} defaultMessage={'Use A New Card'}/></span>
            </div>
        }
    </div>
}